import useGameState, { ONBOARDING_PHASE } from "app/game/useGameState";
import mixpanel from "mixpanel-browser";
import { useCallback, useState } from "react";
import NewPlayerPanel from "./NewPlayerPanel";
import { type TutorialLevel } from "./tutorial-data";
import TUTORIAL_LEVEL_ORDER from "./tutorial-level-order";
import TutorialProgressPanel from "./TutorialProgressPanel";
import TutorialSkipConfirm from "./TutorialSkipConfirm";
import useTutorialState from "./useTutorialState";

interface OnboardingOverlaysProps {
  onTutorialLevelStarted: (level: TutorialLevel) => void;
  onTutorialFinished: () => void;
}

// Manages the overlays related to new player onboarding.
export default function OnboardingOverlays({
  onTutorialLevelStarted,
  onTutorialFinished,
}: OnboardingOverlaysProps) {
  const [showSkipPanel, setShowSkipPanel] = useState(false);
  const {
    id: game_id,
    onboardingPhase,
  } = useGameState();
  const { isInTutorial } = useTutorialState();

  const onNewPlayerPanelStart = useCallback(() => {
    mixpanel.track("onboarding_start", { game_id });
    onTutorialLevelStarted(TUTORIAL_LEVEL_ORDER[0]);
  }, [game_id, onTutorialLevelStarted]);

  if (isInTutorial) {
    return <></>;
  }

  if (showSkipPanel) {
    return (
      <TutorialSkipConfirm
        onBackOut={() => setShowSkipPanel(false)}
        onConfirm={() => onTutorialFinished()}
      />
    );
  }

  if (onboardingPhase === ONBOARDING_PHASE.NEW_PLAYER) {
    return (
      <NewPlayerPanel
        onStartTutorial={onNewPlayerPanelStart}
        onSkipTutorial={() => setShowSkipPanel(true)}
      />
    );
  } else if (onboardingPhase === ONBOARDING_PHASE.STARTED) {
    return (
      <TutorialProgressPanel
        onLevelStarted={() => {}}
        onSkip={() => setShowSkipPanel(true)}
        onAllFinished={() => onTutorialFinished()}
      />
    );
  }
}
